module.exports = __webpack_public_path__ + "img/ie.487a670.svg";